import clsx from 'clsx';
import type { ReactNode } from 'react';

export interface TableIconBadgeProps {
  className?: string;
  /**
   * The icon — pass UNSIZED. The badge container drives the 40-square
   * outer shape; the caller picks icon size at the call site (e.g.
   * `<FileTextIcon className="size-5 text-foreground" aria-hidden />`).
   */
  children: ReactNode;
}

/**
 * 40-square rounded container used in the leading cell of each data row
 * (file/folder/icon framing). Pure presentation, zero state.
 *
 * The `dark:bg-surface-raised` override is INTENTIONAL. Verified in
 * `monks-ui/src/styles/globals.css`: `--surface` and `--surface-raised`
 * are DIFFERENT tokens per theme (light: `neutral-50` / `neutral-200`;
 * dark: `stone-800` / `stone-700`). Using the lighter dark-mode token
 * (`--surface-raised`) lifts the badge off the row background so it stays
 * visible in dark mode, where `bg-surface` alone would blend into the row.
 */
export const TableIconBadge = ({ className, children }: TableIconBadgeProps) => (
  <div
    className={clsx(
      'flex size-10 shrink-0 items-center justify-center rounded-lg bg-surface dark:bg-surface-raised',
      className,
    )}
  >
    {children}
  </div>
);
TableIconBadge.displayName = 'TableIconBadge';
